import {
	getTablePriceOperation,
	getTablePriceRespect,
	getTablePriceRound,
	getTablePriceRoundWay,
	getTablePriceTypeData
} from 'actions'
import ConfirmModalNoButton from 'components/common/ConfirmModalNoButton'
import NotificationError from 'components/common/notificationsErrors'
import ProductImport from 'components/ProductImport'
import { principalConfigFields } from 'constants/voucherConfig/PricesAndCostsMassiveUploadConfig/PricesAndCostsMassiveUploadConfigFields'
import { Form, Formik, FormikProps } from 'formik'
import { getInitValues, getValidationSchema } from 'lib/FieldValidations'
import { IPricesAndCostsFormProps } from 'models/PricesAndCostsMassiveUploadInterface'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import PricesAndCostsMassiveUploadFormUpdateFields from './PricesAndCostsMassiveUploadFormUpdateFields'

class PricesAndCostsForm extends Component<IPricesAndCostsFormProps> {
	componentDidMount = () => {
		this.props.getTablePriceTypeData()
		this.props.getTablePriceOperation()
		this.props.getTablePriceRespect()
		this.props.getTablePriceRound()
		this.props.getTablePriceRoundWay()
	}

	render() {
		const {
			t,
			fields,
			handleCalculate,
			itemInfo,
			handleVerify,
			showVerificationModal,
			handleConfirm,
			handleClosePopup,
			idOperacion,
			errorMessage
		} = this.props

		const disableForm = false

		const initialValues =
			itemInfo || (fields.length ? getInitValues(fields) : {})
		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {}

		return (
			<Formik
				initialValues={initialValues}
				onSubmit={(values, actions) => {
					handleCalculate(values)
				}}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(props: FormikProps<any>) => (
					<Fragment>
						<Col sm={12}>
							<NotificationError
								errors={props.errors}
								touched={props.touched}
							/>
						</Col>
						<Col sm={12}>
							<Alert variant={'dark'}>
								<b>{t('CRUDS.general_use.prices_update')}</b>
							</Alert>
						</Col>
						<Form className="container-fluid">
							<Row className="row justify-content-md-center mb-3">
								<Col lg={8} className={'text-center, mx-8'}>
									<Row>
										{_.map(fields, (field) => {
											const selectedFieldConfig = principalConfigFields.find(
												(fieldConfig) => {
													return fieldConfig.id === field.idCampo
												}
											)
											return (
												<Col
													className={
														(selectedFieldConfig &&
															selectedFieldConfig.height) ||
														'col-sm-12'
													}
												>
													<PricesAndCostsMassiveUploadFormUpdateFields
														key={field.idCampo}
														formikProps={props}
														field={field}
														crudProps={{
															...this.props
														}}
														initialValue={
															initialValues[
																field.idCampo as keyof typeof initialValues
															]
														}
													/>
												</Col>
											)
										})}
									</Row>
								</Col>

								<Col lg={3} className={'text-center, mx-3'}>
									<Row
										className="justify-content-center text-center mt-4"
										style={{ marginBottom: '-10px' }}
									>
										{!disableForm && (
											<Button
												style={{
													minWidth: '145px',
													margin: '20px'
												}}
												type={'submit'}
												onClick={() => handleCalculate}
											>
												{t('Collection.form.buttons.calculate')}
											</Button>
										)}
										<div
											style={{
												minWidth: '145px',
												margin: '20px'
											}}
										>
											<ProductImport
												minWidth={'145px'}
												idOperacion={idOperacion}
											/>
										</div>
									</Row>

									<Row className="justify-content-center text-center">
										<Button
											style={{
												minWidth: '145px',
												margin: '20px'
											}}
											type={'button'}
											onClick={() => {}}
										>
											{t('Collection.form.buttons.cancel')}
										</Button>

										<Button
											style={{
												minWidth: '145px',
												margin: '20px'
											}}
											type={'button'}
											onClick={() => handleVerify(props.values)}
										>
											{t('Collection.form.buttons.confirm')}
										</Button>

										<ConfirmModalNoButton
											modalTitle={t('CRUDS.modal.title_warning')}
											messageBody={errorMessage}
											showModal={showVerificationModal}
											handleCloseModal={() => handleClosePopup()}
											handleCancelButton={() => handleClosePopup()}
											handleSubmitButton={() => {
												handleConfirm()
												handleClosePopup()
											}}
										/>
									</Row>
								</Col>
							</Row>
						</Form>
					</Fragment>
				)}
			</Formik>
		)
	}
}
const mapStateToProps = ({ tableCalls }: any) => {
	const {
		priceTypeData,
		priceOperation,
		priceRespect,
		priceRound,
		priceRoundWay
	} = tableCalls

	return {
		priceTypeData,
		priceOperation,
		priceRespect,
		priceRound,
		priceRoundWay
	}
}

const connectForm = connect(mapStateToProps, {
	getTablePriceTypeData,
	getTablePriceOperation,
	getTablePriceRespect,
	getTablePriceRound,
	getTablePriceRoundWay
})(PricesAndCostsForm)

export default withTranslation()(withRouter(connectForm))
